export const CLASS_NAMES = {
  optionItem: 'bagel-autocomplete-option',
  optionName: 'bagel-autocomplete-option-name',
} as const;

export const OVERLAY_AUTOCOMPLETE_MENU_PROPS = {
  withinPortal: false,
  trapFocus: false,
  zIndex: 400,
} as const;
